module.exports = __webpack_public_path__ + "img/hero-main-1.8dcdd2df.png";